// Description: This file contains functions to interact with the Firestore database for managing messages and threads.
// It includes functions to get, set, and stream email settings, messages, and threads for a specific firm and user.

import { db } from "./db.js";
import { ref } from "vue";

// ==================== SETTINGS ====================

//TODO error handler should be passed from the store so it can try to resubscribe.
function streamEmailSettings(firmId, userId, onSnap) {
  console.log(`firms/${firmId}/members/${userId}`);
  return db.doc(`firms/${firmId}/members/${userId}`)
    .onSnapshot(
      onSnap,
      (error) => { console.log(error); }
    );
}

// Multi-account model: the member doc carries an `emailAccounts` map keyed by
// email address plus `activeEmailAddress`. Email addresses contain dots, so
// dot-path updates would corrupt the map — always write the whole map with a
// merge set. The store keeps the accounts map fresh via streamEmailSettings,
// so whole-map read-modify-write here is safe.
async function setEmailAccounts(firmId, userId, emailAccounts, activeEmailAddress) {
  const data = { emailAccounts };
  if (activeEmailAddress !== undefined) {
    data.activeEmailAddress = activeEmailAddress;
  }
  return await db.doc(`firms/${firmId}/members/${userId}`)
    .set(data, {merge: true} );
}

// ==================== MESSAGES ====================

async function getFSmessage(firmId, userId, messageId) {
  try {
  const message = await db.doc(`firms/${firmId}/members/${userId}/messages/${messageId}`).get();
  return message.exists ? message.data() : null;
  } catch(err) {
    console.log("in get message");
    throw(err);
  }
}

async function setFSmessage(firmId, userId, messageId, message) {
  try {
  return await db.doc(`firms/${firmId}/members/${userId}/messages/${messageId}`).set(message);
  } catch(err) {
    console.log("in set message");
    throw(err);
  }
}

async function getFSmessages(firmId, userId, patentId=null, startAfter=null) {
  let messageQuery = db.collection(`firms/${firmId}/users/${userId}/messages`).orderBy("date").limit(100);
  if (patentId) {
    messageQuery = messageQuery.where("patentIds", "array-contains", patentId);
  }
  if (startAfter) {
    messageQuery = messageQuery.startAfter(startAfter);
  }
  const querySnapshot = await messageQuery.get();
  return querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}

// =================== THREADS =====================
//  TODO: this is repetitive.
//

async function getFSthread(firmId, userId, threadId) {
  try {
  const thread = await db.doc(`firms/${firmId}/members/${userId}/threads/${threadId}`).get();
  console.log("in getFSthread");
  console.log(thread);
  return thread.exists ? thread.data() : null;
  } catch(err) {
    console.log("error in get thread");
    throw(err);
  }
}

async function setFSthread(firmId, userId, threadId, data) {
  try {
    // first, check if thread exists or whether its isRelevant field is true; if not, then set data
    const thread = await db.doc(`firms/${firmId}/members/${userId}/threads/${threadId}`).get();
    if (thread.exists && thread.data().isRelevant) {
      console.log("thread exists and isRelevant");
      // merge thread.patentIds with data.patentIds
      const newPatentIds = [...new Set([...thread.data().patentIds, ...data.patentIds])];
      data.patentIds = newPatentIds;
      // set data with merge
      return await db.doc(`firms/${firmId}/members/${userId}/threads/${threadId}`).set(data, {merge: true});
    }
    else {
      return await db.doc(`firms/${firmId}/members/${userId}/threads/${threadId}`).set(data);
    }
  } catch(err) {
    console.log("in set thread");
    throw(err);
  }
}

async function updateFSthread(firmId, userId, threadId, thread) {
  try {
    return await db.doc(`firms/${firmId}/members/${userId}/threads/${threadId}`).set(thread, {merge: true});
  } catch(err) {
    console.log("in set thread");
    throw(err);
  }
}

function deleteFSthread(firmId, userId, threadId) {
  return db.doc(`firms/${firmId}/members/${userId}/threads/${threadId}`).delete();
}


async function getFSthreads(firmId, userId, patentId=null, startAfter=null) {
  // build query, make sure threads are ordered by date descending
  let threadQuery = db.collection(`firms/${firmId}/members/${userId}/threads`).orderBy("date", "desc")
  if (patentId) {
    threadQuery = threadQuery.where("patentIds", "array-contains", patentId);
  }
  if (startAfter) {
    threadQuery = threadQuery.startAfter(startAfter);
  }
  // return onsnapshot promise
  const firestore_threads = ref([]);
  return new Promise((resolve, reject) => {
    const unsubscribe = threadQuery.onSnapshot(
      (querySnapshot) => {
        firestore_threads.value = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        resolve({firestore_threads, unsubscribe});
      }
      , reject
    );
  });
}

export {
  getFSmessage,
  setFSmessage,
  getFSmessages,
  getFSthread,
  setFSthread,
  updateFSthread,
  getFSthreads,
  streamEmailSettings,
  setEmailAccounts,
  deleteFSthread
};


